import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "w-1/4 space-y-7 align-middle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Name", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Owner", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Device info", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "flex items-center justify-center justify-items-center align-middle" }
const _hoisted_13 = { class: "ml-4 flex w-3/4 flex-col gap-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "ml-1 font-semibold" }, "Device Location"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }),
  /*#__PURE__*/_createElementVNode("p", { class: "mr-2 text-xs font-semibold text-red-500" }, " (Double click for pick) ")
], -1)
const _hoisted_15 = {
  id: "map",
  class: "h-[40vh] relative w-full rounded-lg"
}
const _hoisted_16 = {
  key: 0,
  class: "z-[2500] absolute inset-x-0 bottom-1 flex items-center justify-center"
}
const _hoisted_17 = { class: "flex items-center gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TheButton = _resolveComponent("TheButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_InputField, {
          "model-value": _ctx.currentDevice.assignment?.name,
          "no-padding": true,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateModelValue($event.target.value)))
        }, null, 8, ["model-value"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        (_ctx.currentDevice.assignment?.user.email)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'envelope'],
                class: "mr-1"
              }),
              _createTextVNode(" Email: "),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.currentDevice.assignment?.user.email), 1)
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_7, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'envelope'],
                class: "mr-1"
              }),
              _createTextVNode(" Email not found ")
            ]))
      ]),
      _createElementVNode("div", null, [
        _hoisted_8,
        (_ctx.currentDevice.device?.mac)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fac', 'bluetooth'],
                class: "mr-1"
              }),
              _createTextVNode(" MAC: "),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.currentDevice.device?.mac), 1)
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_11, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fac', 'bluetooth'],
                class: "mr-1"
              }),
              _createTextVNode(" MAC address not found ")
            ]))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_TheButton, {
          text: 'Save changes',
          "is-disabled": 
            !_ctx.currentDevice.assignment?.permissions.find(
              (permission) => permission.id === _ctx.permissions.EditAssignment
            )
          ,
          variant: 
            _ctx.currentDevice.assignment?.permissions.find(
              (permission) => permission.id === _ctx.permissions.EditAssignment
            )
              ? 'default'
              : 'ghost'
          ,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveChanges()))
        }, null, 8, ["is-disabled", "variant"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        (_ctx.markerCoordinatesChanged)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_TheButton, {
                  size: 'sm',
                  text: 'Cancel',
                  class: "!h-fit",
                  "is-disabled": 
                !_ctx.currentDevice.assignment?.permissions.find(
                  (permission) => permission.id === _ctx.permissions.EditAssignment
                )
              ,
                  variant: 
                _ctx.currentDevice.assignment?.permissions.find(
                  (permission) => permission.id === _ctx.permissions.EditAssignment
                )
                  ? 'default'
                  : 'ghost'
              ,
                  onClick: _ctx.cancelButton
                }, null, 8, ["is-disabled", "variant", "onClick"]),
                _createVNode(_component_TheButton, {
                  size: 'sm',
                  text: 'Save',
                  class: "!h-fit",
                  "is-disabled": 
                !_ctx.currentDevice.assignment?.permissions.find(
                  (permission) => permission.id === _ctx.permissions.EditAssignment
                )
              ,
                  variant: 
                _ctx.currentDevice.assignment?.permissions.find(
                  (permission) => permission.id === _ctx.permissions.EditAssignment
                )
                  ? 'default'
                  : 'ghost'
              ,
                  onClick: _ctx.saveButton
                }, null, 8, ["is-disabled", "variant", "onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}